









































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import usuarioModule from "@/store/usuario/UsuarioModule";
import { EstadoModel, estadosList } from "@/models/commons/EstadoModel";
import { EnderecoModel, TipoEnderecoModel } from '@/models/commons/EnderecoModel';
import {
  tiposTelefoneList,
  ITelefoneModel,
} from "@/models/commons/TelefoneModel";
import { tiposResponsavelList } from "@/models/commons/ResponsavelModel";
import { ClienteFrotaModel } from "@/models/cadastros/assistencia/ClienteFrotaModel";
import { tiposEnderecoList } from "@/models/commons/EnderecoModel";
import { tiposVeliculoList, TipoVeiculoModel, } from "@/models/commons/TipoVeiculoModel";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import ServicosAssistenciaService from "@/service/assistencia24h/ServicosAssistenciaService";
import { mapasService } from "@/service/MapasService";
import { moneyMaskProperties } from "@/models/VuetifyMoneyModel";
import { VeiculoModel } from "@/models/veiculo/VeiculoModel";
import ConsultaVeiculo from "./ConsultaVeiculo.vue";
import { SegmentoDTO } from "@/models/commons/SegmentoModel";
import { AgenteModel, ListaAgentesModel } from "@/models/cadastros/assistencia/agente/AgenteModel";
import { ClienteContatoModel } from '@/models/commons/ClienteContatoModel';

// @ts-ignore
import _ from 'lodash';
import moment from "moment";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    ConsultaVeiculo,
    GsModalDialog
  },
})
export default class CadastroPrestador extends Vue {
  $refs!: {
    dadosBasicosObserver: InstanceType<typeof ValidationObserver>;
    telefoneObserver: InstanceType<typeof ValidationObserver>;
    veiculoObserver: InstanceType<typeof ValidationObserver>;
    informacaoObserver: InstanceType<typeof ValidationObserver>;
  };
  segmentos: SegmentoDTO[] = [];

  endereco: EnderecoModel = {
    cep: "",
    logradouro: "",
    numero: undefined,
    complemento: "",
    bairro: "",
    cidade: "",
    estado: undefined,
  };

  contato: ClienteContatoModel = {
    nome: "",
    cpf: "",
    dataNascimento: undefined,
    email: "",
    ddd: "",
    numero: ""
  }

  itemParaExcluir: any;

  crud: ClienteFrotaModel = {
    endereco: this.endereco,
    telefones: [],
    veiculos: [],
    fatura: {},
    cpfCnpj: "",
    agente: {} as AgenteModel,
    contato: this.contato,
    isOrgaoPublico: false
  };

  informacao: any = {};
  telefone: ITelefoneModel = {};

  veiculoReset: VeiculoModel = {
    placa: "",
    chassi: "",
    marca: "",
    modelo: "",
    anoFabricacao: "",
    anoModelo: "",
    cor: "",
  };

  veiculo: VeiculoModel = {
    placa: "",
    chassi: "",
    marca: "",
    modelo: "",
    anoFabricacao: "",
    anoModelo: "",
    cor: "",
    combustivel: "",
    cilindrada: "",
  };

  totalVeiculo: any = {
    LEVE: { quantidade: 0 },
    UTILITARIO: { quantidade: 0 },
    PESADO: { quantidade: 0 },
    ULTRA_PESADO: { quantidade: 0 },
    TOTAL: 0
  }

  moneyMaskProperties = moneyMaskProperties;
  telefoneValido = false;
  veiculoValido = false;
  informacaoValido = false;

  tiposVeiculos = tiposVeliculoList;

  loadingAddress = false;
  ehLeveUtilitario = false;
  ehPesadoExtraPesado = false;

  estados = estadosList;
  cidades: string[] = [];

  tiposResponsavel = tiposResponsavelList;
  tiposTelefone = tiposTelefoneList;
  tipoVeiculo = tiposVeliculoList;
  tiposEndereco = tiposEnderecoList;

  cabecalhoTelefone = [
    { text: "Nome Responsável", value: "nome" },
    { text: "Tipo Número", value: "tipo.descricao" },
    { text: "Número", value: "numero" },
    { text: "Ramal", value: "ramal" },
  ];
  cabecalhoInformacao = [
    { text: "Data", value: "dataCriacao", width: "25%" },
    { text: "Usuário", value: "usuario", width: "35%" },
    { text: "Registo", value: "observacao", width: "25%" },
    { text: "Ações", value: "actions", sortable: false },
  ];
  cabecalhoVeiculo = [
    { text: "Placa", value: "placa" },
    { text: "Modelo", value: "modelo" },
    { text: "Ano", value: "anoFabricacao" },
    //{ text: "Ano Modelo", value: "anoModelo" },
    //{ text: "Marca", value: "marca" },
    { text: "Chassi", value: "chassi" },
    { text: "Categoria", value: "tipoVeiculo.descricao" },
  ];

  tipoPopup = "";
  dialogType = "success";
  showDialog = false;
  dialogTitle = "";
  dialogMessage = "";

  loading = false;
  
  @Watch('crud.endereco.cep')
  private consultCEP(val: string): void {
    if (val != undefined) {
      this.requestAddress(val);
    }
  }

  requestAddress(val: string): void {
    val = val.replace(/\D/g, "");
    if (val && val.length === 8) {
      this.loadingAddress = true;
      mapasService
        .obterEnderecoPorCep(val.replace(/\D/g, ""))
        .then((res) => {
          const address: EnderecoModel = this.crud.endereco ?? {};

          if (res.logradouro) {
            address.logradouro = res.logradouro;
          }
          if (res.bairro) {
            address.bairro = res.bairro;
          }
          if (res.cidade) {
            address.cidade = res.cidade;
          }

          if (res.estado) {
            address.estado = estadosList.find(
              (e) => e.sigla == (res.estado?.sigla || "")
            );
          } else {
            address.estado = undefined;
          }
          this.crud.endereco = address;
        })
        .finally(() => {
          this.loadingAddress = false;
        });
    } else {
      if (val && val.length < 8) {
        this.limparEndereco();
      }
    }
  }

  limparEndereco() {

    let enderecoLimpo: EnderecoModel = {
      cep: "",
      logradouro: "",
      numero: undefined,
      complemento: "",
      bairro: "",
      cidade: "",
      estado: undefined,
    };

    this.crud.endereco = enderecoLimpo;
  }

  obterSegmentos() {
    this.loading = true;
    this.segmentos = [];
    ServicosAssistenciaService
      .obterSegmentos(
    ).then((res: SegmentoDTO[]) => {
      this.segmentos = res;

      this.segmentos = _.orderBy( this.segmentos, ['descricao']);

      this.loading = false;
    })
      .catch((err) => {
        this.loading = false;
        console.log(err);
      });
  }

  loadInfo() {
    // limpar o cadastro antes de carregar as infos
    this.telefone = {};
    this.veiculo = Object.assign({}, this.veiculoReset);
    this.informacao = {};
    this.crud = {
      fatura: {},
      endereco: {},
      telefones: [],
      veiculos: [],
      cpfCnpj: '',
      agente: {} as AgenteModel,
      contato: {},
      isOrgaoPublico: false
    };

    // carregar as infos
    if (this.$route.params.idCliente) {
      ServicosAssistenciaService.obterClienteFrota(
        this.$route.params.idCliente
      ).then((response) => {
        let resultado = response.data;
        this.crud = resultado;
        if (this.crud.fatura == null) {
          this.crud.fatura = {};
        }

        this.crud.endereco!!.tipo = _.find(this.tiposEndereco, function (o: any) {
          return o.nome == resultado.endereco.tipo;
        });

        this.crud.telefones = _.map(resultado.telefones, (t: any) => {
          return _.assign({}, t, {
            numero: `(${t.ddd}) ${t.numero}`,
            tipo: _.find(this.tiposTelefone, function (o: any) { return o.nome == t.tipo; }),
            tipoResponsavel: _.find(this.tiposResponsavel, function (o: any) { return o.nome == t.tipoResponsavel; })
          });
        });

        this.crud.veiculos = _.map(resultado.veiculos, (t: any) => {
          return _.assign({}, t, {
            tipoVeiculo: _.find(this.tiposVeiculos, function (o: any) { return o.name == t.tipoVeiculo; }),
            estadoRegiaoFrota: _.find(estadosList, function (o: any) { return o.sigla == t.estadoRegiaoFrota || ""; })
          });
        });

        this.calcularRodapeVeiculo();
      });
    }
  }

  mounted() {
    this.loadInfo();
    this.obterSegmentos();
  }

  //Computed properties
  get textoBotaoTelefone() {
    return this.telefone &&
      this.telefone?.id !== undefined &&
      this.telefone?.id >= 0
      ? "Salvar contato"
      : "Adicionar contato";
  }

  get textoBotaoVeiculo() {
    return this.veiculo &&
      this.veiculo?.placa !== ''
      ? "Salvar veículo"
      : "Adicionar veículo";
  }

  get textoBotaoInformacao() {
    return this.informacao &&
      this.informacao?.id !== undefined &&
      this.informacao?.id >= 0
      ? "Salvar Informação"
      : "Adicionar Informação";
  }

  calcularRodapeVeiculo() {
    let soma = _.map(this.tiposVeiculos, (tv: any) => {
      return _.assign({}, tv, {
        quantidade: _.sumBy(this.crud.veiculos, function (o: any) { return tv.name == o.tipoVeiculo.name; }) | 0
      });
    });

    this.totalVeiculo = _.keyBy(soma, 'name');
    this.totalVeiculo.TOTAL = this.crud.veiculos?.length;
  }

  // VEICULO
  adicionarVeiculo() {
    this.$refs.veiculoObserver.validate().then((res: boolean) => {
      if (res) {
        let veiculoInfoCar = this.veiculo;
        this.veiculo = _.assign({}, veiculoInfoCar, {
          tipoVeiculo: _.find(this.tiposVeiculos, function (o: any) { return o.name == veiculoInfoCar.tipoVeiculo!.name; })
        });

        if (!this.crud.veiculos) {
          this.crud.veiculos = [this.veiculo];
        }

        const idx = this.crud.veiculos
          .map((t) => t.placa)
          .indexOf(this.veiculo.placa);
        if (idx >= 0) {
          this.crud.veiculos.splice(idx, 1, this.veiculo);
        } else {
          this.crud.veiculos.push(this.veiculo);
        }
        this.veiculo = Object.assign({}, this.veiculoReset);
        this.$refs.veiculoObserver.reset();
      }

      this.calcularRodapeVeiculo();
    });
  }

  alterarVeiculo(veiculo: VeiculoModel) {
    this.veiculo = Object.assign({}, veiculo);
  }

  removerVeiculo(veiculo: VeiculoModel) {    
    this.itemParaExcluir = veiculo;
    this.excluir('Deseja realmente excluir o veículo? Se confirmar, poderá perder os dados.', 'VEICULO');
  }

  removerVeiculoConfirmation() {    
    if (this.crud.veiculos) {
      const idx = this.crud.veiculos
        .map((t) => t)
        .indexOf(this.itemParaExcluir);
      this.crud.veiculos.splice(idx, 1);
      this.calcularRodapeVeiculo();
    }
  }

  cancelarVeiculo() {
    this.veiculo = Object.assign({}, this.veiculoReset);
  }

  // TELEFONE
  adicionarTelefone() {
    this.$refs.telefoneObserver.validate().then((res: boolean) => {
      if (res) {
        if (!this.crud.telefones) {
          this.crud.telefones = [this.telefone];
        }
        const partes = this.telefone.numero?.split(" ") as string[];
        if (partes.length == 3) {
          this.telefone.numero = `${partes[0]} ${partes[1]}${partes[2]}`;
        }

        let idx = -1;
        idx = this.crud.telefones
          .map((t) => t.id)
          .indexOf(this.telefone.id);

        if (idx == -1) {
          idx = this.crud.telefones
          .map((t) => t.ddd + (t.numero || '0'))
          .indexOf(this.telefone.ddd + (this.telefone.numero || '0'));
        } 
       
        if (idx >= 0) {
          this.crud.telefones.splice(idx, 1, this.telefone);
        } else {
          this.crud.telefones.push(this.telefone);
        }
        this.telefone = {};
        this.$refs.telefoneObserver.reset();
      }
    });
  }

  alterarTelefone(telefone: ITelefoneModel) {
    this.telefone = Object.assign({}, telefone);
  }

  removerTelefone(telefone: ITelefoneModel) {
    this.itemParaExcluir = telefone;
    this.excluir('Deseja realmente excluir o contato? Se confirmar, poderá perder os dados.', 'CONTATO');
  }

  removerTelefoneConfirmation() {    
    if (this.crud.telefones) {
      const idx = this.crud.telefones
        .map((t) => t)
        .indexOf(this.itemParaExcluir);
      this.crud.telefones.splice(idx, 1);
    }
  }

  cancelarTelefone() {
    this.telefone = {};
  }

  // INFORMACAO
  get nomeLogin() {
    const nome = usuarioModule.token?.name.split(" ");
    if (nome) {
      return nome.length > 1
        ? `${nome[0]} ${nome[1]}${nome[1].length < 3 && nome[2] ? ` ${nome[2]}` : ""
        }`
        : nome[0];
    } else {
      return "";
    }
  }

  adicionarInformacao() {
    this.$refs.informacaoObserver.validate().then((res: boolean) => {
      if (res) {

        if (!this.crud.informacoes) {
          this.informacao = _.assign({}, this.informacao, {
            usuario: this.nomeLogin,
            dataCriacao: moment().format("YYYY-MM-DDTHH:mm:ss")
          });
          
          this.crud.informacoes = [this.informacao];
        }

        const idx = this.crud.informacoes
          .map((t) => t.dataCriacao)
          .indexOf(this.informacao.dataCriacao);
        if (idx >= 0) {
          this.crud.informacoes.splice(idx, 1, this.informacao);
        } else {
          this.informacao = _.assign({}, this.informacao, {
            usuario: this.nomeLogin,
            dataCriacao: moment().format("YYYY-MM-DDTHH:mm:ss")
          });
          this.crud.informacoes.push(this.informacao);
        }
        this.informacao = {};
        this.$refs.informacaoObserver.reset();
      }
    });
  }

  alterarInformacao(informacao: any) {
    this.informacao = Object.assign({}, informacao);
  }

  removerInformacao(informacao: any) {
    this.itemParaExcluir = informacao;
    this.excluir('Deseja realmente excluir a informação? Se confirmar, poderá perder os dados.', 'INFORMACAO');
  }

  removerInformacaoConfirmation() {    
    if (this.crud.informacoes) {
      const idx = this.crud.informacoes
        .map((t) => t)
        .indexOf(this.itemParaExcluir);
      this.crud.informacoes.splice(idx, 1);
    }
  }

  cancelarInformacao() {
    this.informacao = {};
  }

  excluir(mensagem: string, tipo: string) {
    // 'Deseja realmente excluir o veículo? Se confirmar, poderá perder os dados.'
    this.openDialog('confirm', 'Atenção', mensagem, tipo);
  }

  cancelar() {
    this.openDialog('confirm', 'Cancelar alterações', 'Deseja realmente cancelar o cadastro? Se confirmar, poderá perder os dados.', 'IGNORE');
  }

  voltarPagina() {
    this.$router.back();
  }

  gravar() {
    this.$refs.dadosBasicosObserver.validate().then((valid) => {
      if (valid) {
        if (!this.crud.telefones || this.crud.telefones.length <= 0) {
          this.openDialog('error', 'Nenhum contato adicionado', 'Nenhum contato foi adicionado para o cliente.');
          valid = false;
        }

        if (valid) {
          if (this.crud.id) {
            this.save();
          } else {
            ServicosAssistenciaService.verificarCpfCnpj(
              this.crud.cpfCnpj || ""
            ).then((existe: any) => {
              if (!existe.data) {
                this.save();
              } else {
                this.openDialog('error', 'Prestador já cadastrado', `Já existe um prestador cadastrado para o CNPJ informado.`);
              }
            });
          }
        }
      } else {
        setTimeout(() => {
          const errors = Object.entries(this.$refs.dadosBasicosObserver.errors)
            .map(([key, value]) => ({ key, value }))
            .filter((error) => error["value"].length);
          this.$refs.dadosBasicosObserver.refs[
            errors[0]["key"]
          ].$el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }, 100);
      }
    });
  }

  save() {
    this.loading = true;
    ServicosAssistenciaService.saveClienteFrota(this.crud).then(
      (res) => {
        if (this.crud.id) {
          this.dialogTitle = "Alteração efetivada com sucesso";
          this.dialogMessage = "Cliente frota alterado com sucesso";
        } else {
          this.dialogTitle = "Cadastro efetivado com sucesso";
          this.dialogMessage = "Cadastro do cliente frota efetivado com sucesso";
        }
        this.openDialog('success', this.dialogTitle, this.dialogMessage);
        this.loading = false;
      },
      (err) => {
        this.openDialog('error', 'Erro ao gravar cliente frota', 'Ocorreu um erro ao tentar gravar os dados do cliente frota.');
        this.loading = false;
      }
    );
  }

  private openDialog(dialogType: string, title: string, message: string, type?: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;

    if (dialogType == 'confirm') {
      this.tipoPopup = type!!;
    }
  }

  public closeDialog(): void {
    this.showDialog = false;
    if (this.dialogType === 'success') {
      this.$router.push({ name: "ListaAssociadosFrota" });
    }
  }

  public confirm() {
    this.closeDialog();
    if (this.tipoPopup == 'VEICULO') {
      this.removerVeiculoConfirmation();  
    } else if (this.tipoPopup == 'CONTATO') {
      this.removerTelefoneConfirmation();
    } else if (this.tipoPopup == 'INFORMACAO') {
      this.removerInformacaoConfirmation();
    }
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      case "confirm":
        color = "warning";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }
}
